import React from 'react';
import { Eyebrow, SectionLead, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { tomos } from '../../data/content';
export function Tomos() {
  return <SectionShell tone="renal" data-id="element-264" data-mp="7wt6aivc8xuq">
      <Eyebrow data-id="element-265" data-mp="7xkz5lxjwhhb">El contenido</Eyebrow>
      <SectionTitle data-id="element-266" data-mp="cw60joojh77c">¿Qué contiene Ruta Enfermedad Renal™?</SectionTitle>
      <SectionLead data-id="element-267" data-mp="cy8qy9tlt2cl">
        Un sistema completo que te acompaña desde la primera creatinina alterada hasta el
        seguimiento del paciente renal.
      </SectionLead>

      <div className="mt-8 space-y-3.5" data-id="element-268" data-mp="3gdnx2zyv2rsg">
        {tomos.map(tomo => <article key={tomo.tomo} className="rounded-2xl border border-renal-600/15 bg-white p-4 sm:p-6" data-id="element-269" data-mp="3lbfxyjhhho8s">
            <div className="flex items-center gap-3" data-id="element-270" data-mp="3qcdgwyabimbc">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-271" data-mp="10m9x5c3b86ou">
                {tomo.emoji}
              </span>
              <span className="rounded-full bg-navy-800 px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-272" data-mp="15jidr88t82nz">
                {tomo.tomo}
              </span>
            </div>
            <h3 className="mt-3 font-display text-[20px] font-extrabold leading-tight text-navy-900 sm:text-2xl" data-id="element-273" data-mp="1cuz07lpmvsan">
              {tomo.title}
            </h3>
            <p className="mt-2 text-[14px] font-semibold leading-snug text-renal-700 sm:text-[15px]" data-id="element-274" data-mp="13t99yj7hmzeg">
              {tomo.lead}
            </p>
            <p className="mt-2 text-[13.5px] leading-relaxed text-navy-700/80 sm:text-[14.5px]" data-id="element-275" data-mp="yvha930lq8zp">
              {tomo.text}
            </p>
          </article>)}
      </div>

      <div className="mt-8" data-id="element-276" data-mp="p54s1hg9erwq">
        <CtaButton label="Quiero los 6 tomos completos" sub="6 tomos premium + 5 bonos • Descarga inmediata" data-id="element-277" data-mp="p4ctbxrd8e28" />
      </div>
    </SectionShell>;
}